import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';

import { useCalDavStore } from '../../store';

interface CalDavDeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const CalDavDeleteConfirmDialog: React.FC<CalDavDeleteConfirmDialogProps> = observer(
  ({ open, onClose, onSuccess }) => {
    const store = useCalDavStore();

    const handleDelete = useCallback(async () => {
      try {
        await store.deleteConfig();
        onSuccess?.();
        onClose();
      } catch {
        // Error is handled in store
      }
    }, [store, onClose, onSuccess]);

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        sx={{
          '.MuiPaper-root': {
            borderRadius: '12px',
          },
        }}
      >
        <DialogTitle>Удалить интеграцию CalDav?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Это действие удалит все настройки CalDav и отключит синхронизацию календарей. Данные о
            выбранных календарях будут потеряны.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Отмена</Button>
          <LoadingButton onClick={handleDelete} color="error" loading={store.isDeleteLoading}>
            Удалить
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  },
);
